import * as React from 'react';
import Container from '@mui/material/Container';
import { Button, Divider, FormControl, InputLabel, MenuItem, Paper, Select, Stack, TextField } from '@mui/material';
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnLink,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,
    BtnUndo,
    HtmlButton,
    Separator,
    createButton,

    Editor,
    EditorProvider,
    Toolbar
} from 'react-simple-wysiwyg';

import EditorJS from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/themes/prism.css';
// import 'prismjs/components/prism-javascript';
import { useNavigate, useParams } from "react-router-dom";
import Service from '../../../util/Service';

const BtnAlignCenter = createButton('Align center', '≡', 'justifyCenter');

export default function ModeloForm() {
    const params = useParams();
    const navigate = useNavigate();
    const [code, setCode] = React.useState('');
    const [nome, setNome] = React.useState('');
    const [desc, setDesc] = React.useState('');
    const [tipo, setTipo] = React.useState('CameJS');
    React.useEffect(() => {
        if (params && params.id) {
            Service.GET("/api/security/template/" + params.id)
                .then(r => {
                    setNome( r.nome);
                    setDesc( r.descricao );
                    setCode( r.code);      
                    setTipo( r.tipo);              
                })
        }
    }, [])
    function onChange(e) {
        setCode(e.target.value);
    }
    function handleSave(){
        let dado = {
            id: (params && params.id)?params.id:null,
            nome: nome,
            descricao: desc,
            tipo: tipo,
            code: code
        }  
        
        Service.POST('/api/security/template', dado).then( r =>{
            navigate('/gerenciar/modelos');
        })
    }

    return (
        <Container maxWidth="xl">
            <Paper>
                <Stack direction="row" spacing={1} sx={{m:2}}>
                    <TextField label="Nome" value={nome} variant="outlined" onChange={(e)=> setNome(e.target.value)}/>
                    <TextField onChange={(e) => setDesc(e.target.value)} value={desc}
                        label="Descrição"
                        fullWidth
                        multiline
                        maxRows={4}
                    />
                    <Button onClick={handleSave}>
                        Salvar
                    </Button>
                </Stack>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo do modelo:</InputLabel>
                    <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipo}
                    label="Tipo modelo"
                    onChange={(e)=> setTipo(e.target.value)}
                    >
                    <MenuItem value={'CameJS'}>Camel Script</MenuItem>
                    <MenuItem value={'HTML'}>html</MenuItem>                    
                    </Select>
                </FormControl>
                <Divider sx={{m:2}}/>
                { tipo && tipo === 'HTML' &&
                <EditorProvider >
                    <Editor value={code} onChange={onChange} >
                        <Toolbar>
                            <BtnUndo />
                            <BtnRedo />
                            <Separator />
                            <BtnBold />
                            <BtnItalic />
                            <BtnAlignCenter />                            
                            <BtnUnderline />
                            <BtnStrikeThrough />
                            <Separator />
                            <BtnNumberedList />
                            <BtnBulletList />
                            <Separator />
                            <BtnLink />
                            <BtnClearFormatting />
                            <HtmlButton />
                            <Separator />
                            <BtnStyles />
                        </Toolbar>
                    </Editor>
                </EditorProvider>}
                { tipo && tipo === 'CameJS' &&
                    <EditorJS
                        value={code}
                        onValueChange={t => setCode(t)}
                        highlight={code => {
                            // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                            return highlight(code, languages.js)
                        }}
                        padding={10}
                        style={{
                            fontFamily: '"Fira code", "Fira Mono", monospace',
                            fontSize: 12,
                            minHeight:'400px'
                        }}
                    />
                }
                
            </Paper>
        </Container>
    );
}
